import { getFunctions, httpsCallable } from "firebase/functions";
import { auth } from "../../firebase"; // Adjust the path if necessary

// Generalized function to assign a custom role
export const assignUserRole = async (userId, role) => {
  const functions = getFunctions();
  const setCustomClaims = httpsCallable(functions, "setCustomClaims");

  try {
    await setCustomClaims({ uid: userId, role: role });
    console.log(`Role '${role}' assigned to user ${userId}`);
  } catch (error) {
    console.error("Error assigning role:", error);
  }
};

export const assignApplicantRole = async (userId) => {
  const functions = getFunctions();
  const setCustomClaims = httpsCallable(functions, "setCustomClaims");
  try {
    await setCustomClaims({ uid: userId, role: "applicant" });
    console.log(`Role 'applicant' assigned to user ${userId}`);
  } catch (error) {
    console.error("Error assigning role:", error);
  }
};

// New function to assign the freetrail role
export const assignFreetrialRole = async (userId) => {
  const functions = getFunctions();
  const setCustomClaims = httpsCallable(functions, "setCustomClaims");
  try {
    await setCustomClaims({ uid: userId, role: "freetrial" });
    console.log(`Role 'freetrial' assigned to user ${userId}`);
  } catch (error) {
    console.error("Error assigning role:", error);
  }
};
